import './App.css';
import Header from "./pages/Header";
import Home from "./pages/Home";
import Destinations from "./pages/Destinations";
import Flights from "./pages/Flights";
import Footer from "./pages/Footer";
import Container from '@mui/material/Container';

function App() {
    return (
        <div className="voyagevibes">
            <Header />
            <Container>
                <Home />
                <Destinations />
                <Flights />
            </Container>
            <Footer />
        </div>
    );
}

export default App;
